// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'
import iView from 'view-design'
import i18n from '@/locale'
import menu from './libs/menu'
import common from './libs/util.js'
import config from './libs/config.js'
import numberChinese from '@/libs/numberChinese.js'
import * as echarts from 'echarts'
import { get, post, postFormData, patch, put, exportGet, exportPost } from './libs/axios'
import Viewer from 'v-viewer'
import VueClipboard from 'vue-clipboard2'
import * as WPS from './../static/wps/web-office-sdk-v1.1.5.es.js'
import my_UI from '@/components/common/index.js'
Vue.use(my_UI)

import 'view-design/dist/styles/iview.css'
import 'viewerjs/dist/viewer.css'
import '../static/fontIcon/style.css'
import './assets/myTheme.less'
import './assets/common.scss'
import Meta from 'vue-meta'
Vue.use(Meta)

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
})
import { Cascader, Popup, Field } from 'vant'
Vue.component(Cascader.name, Cascader)
Vue.component(Popup.name, Popup)
Vue.component(Field.name, Field)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999 // 解决图片放大的层级问题
  }
})
Vue.config.productionTip = false // 设置为 false 以阻止 vue 在启动时生成生产提示。
Vue.use(VueClipboard)
Vue.prototype.$Message.config({
  duration: 3
})
Vue.prototype.wps = WPS
Vue.prototype.common = common
Vue.prototype.config = config
Vue.prototype.numberChinese = numberChinese
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$patch = patch
Vue.prototype.$put = put
Vue.prototype.$exportGet = exportGet
Vue.prototype.$exportPost = exportPost
Vue.prototype.$postFormData = postFormData
Vue.prototype.menu = menu.menuJson
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$echarts = echarts

const VUE_APP_VERSION = require('../package.json').version
console.log('VUE_APP_VERSION', VUE_APP_VERSION)
const vers = window.localStorage.getItem('appVersion')
if (VUE_APP_VERSION !== vers) {
  window.localStorage.setItem('appVersion', VUE_APP_VERSION)
  location.reload()
}

/* 路由的前置钩子函数 */
router.beforeEach((to, from, next) => {
  const token = window.localStorage.getItem('token')
  const expiryTime = window.localStorage.getItem('expiryTime')
  const custType = window.localStorage.getItem('custType')
  const whiteListRoute = [
    '/login',
    '/shareList',
    '/uploadIntelligence',
    '/wxShare',
    '/resetPassword'
  ]
  const custTypeRoute = [
    '/login',
    '/shareList',
    '/resetPassword',
    '/channel',
    '/personalCenter/information',
    '/channelCase/channelCivilCase',
    '/channelCase/channelAdministrativeCase',
    '/channelCase/channelCriminalCase',
    '/channelClue/channelAllClue'
  ]
  if (custType == 'C' && !custTypeRoute.includes(to.path)) {
    next('/channel')
  } else {
    if (whiteListRoute.includes(to.path)) {
      next()
    } else if (
      token &&
      expiryTime &&
      new Date().getTime() - expiryTime < 23 * 60 * 60 * 1000
    ) {
      next()
    } else {
      next('/login')
    }
  }
})
/* 路由的后置钩子函数 */
router.afterEach((to, from) => {
  iView.LoadingBar.finish()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js